import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigStateService } from '@abp/ng.core';

export const gerenciamentoDeViagemGuard: CanActivateFn = () => {
  const configState = inject(ConfigStateService);
  const router = inject(Router);

  const enabled = configState.getFeature('cargo_fleet.GerenciamentoDeViagem');
  if (enabled !== 'true') {
    router.navigate(['/']);
    return false;
  }

  return true;
};

export const confirmacaoEntregasGuard: CanActivateFn = () => {
  const configState = inject(ConfigStateService);
  const router = inject(Router);

  const enabled = configState.getFeature('cargo_fleet.ConfirmacaoEntregas');
  if (enabled !== 'true') {
    router.navigate(['/']);
    return false;
  }

  return true;
};

export const flowPayGuard: CanActivateFn = () => {
  const configState = inject(ConfigStateService);
  const router = inject(Router);

  const enabled = configState.getFeature('cargo_fleet.FlowPay');
  if (enabled !== 'true') {
    router.navigate(['/']);
    return false;
  }

  return true;
};

export const gerenciamentoViagensNovoGuard: CanActivateFn = () => {
  const configState = inject(ConfigStateService);
  const router = inject(Router);

  const enabled = configState.getFeature('cargo_fleet.GerenciamentoViagensNovo');
  if (enabled !== 'true') {
    router.navigate(['/']);
    return false;
  }

  return true;
};

export const fleetScoreGuard: CanActivateFn = () => {
  const configState = inject(ConfigStateService);
  const router = inject(Router);

  const enabled = configState.getFeature('cargo_fleet.FleetScore');
  if (enabled !== 'true') {
    router.navigate(['/']);
    return false;
  }

  return true;
};

export const bolsaoGuard: CanActivateFn = () => {
  const configState = inject(ConfigStateService);
  const router = inject(Router);

  const enabled = configState.getFeature('cargo_fleet.Bolsao');
  if (enabled !== 'true') {
    router.navigate(['/']);
    return false;
  }

  return true;
};

// Módulos de OPT-OUT (feature default ON no backend): o guard é idêntico aos de cima, mas o caso
// que ele defende é o inverso — tenant que teve o módulo DESLIGADO não entra por URL direta.
// A raiz '/' é o HomeRedirectComponent, que escolhe um destino que o usuário tem: sem isso, mandar
// para '/' aqui viraria loop de redirect.

export const leilaoGuard: CanActivateFn = () => {
  const configState = inject(ConfigStateService);
  const router = inject(Router);

  const enabled = configState.getFeature('cargo_fleet.Leilao');
  if (enabled !== 'true') {
    router.navigate(['/']);
    return false;
  }

  return true;
};

export const aceitasRecusadasGuard: CanActivateFn = () => {
  const configState = inject(ConfigStateService);
  const router = inject(Router);

  const enabled = configState.getFeature('cargo_fleet.AceitasRecusadas');
  if (enabled !== 'true') {
    router.navigate(['/']);
    return false;
  }

  return true;
};

export const rotasGuard: CanActivateFn = () => {
  const configState = inject(ConfigStateService);
  const router = inject(Router);

  const enabled = configState.getFeature('cargo_fleet.Rotas');
  if (enabled !== 'true') {
    router.navigate(['/']);
    return false;
  }

  return true;
};
